import { RestaurantService } from '@bufteam/cfacorp_d2c.bufbuild_es/cfa/d2c/frontend/restaurant/v1/restaurant_service_pb';
import { TimeslotsService } from '@bufteam/cfacorp_d2c.bufbuild_es/cfa/d2c/timeslots/v1/timeslots_service_pb';
import { CateringService } from '@bufteam/cfacorp_rex-catering.bufbuild_es/cfa/rex/catering/v1/catering_service_pb';
import { createClient } from '@connectrpc/connect';

import ooeConstants from '../constants';
import { getTransportForUrl } from '../services/connectTransport';

const d2cRestaurantTransport = getTransportForUrl(ooeConstants.URL.D2C_CONNECT);
export const d2cRestaurantClient = createClient(RestaurantService, d2cRestaurantTransport);

const rexCateringTransport = getTransportForUrl(ooeConstants.URL.REX_CATERING);
export const rexCateringClient = createClient(CateringService, rexCateringTransport);

const d2cTimeslotsTransport = getTransportForUrl(ooeConstants.URL.D2C_CONNECT);
export const d2cTimeslotsClient = createClient(TimeslotsService, d2cTimeslotsTransport);
